
import sidebar from '~/mixins/sidebar'
import { getPagesPreview } from '~/graphql/fragments-collection.js'

export default {
  mixins: [sidebar],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isTouchDevice: true,
      cards: [],
    }
  },

  computed: {
    graphQlFilter() {
      const filter = {
        site: this.$i18n.locale,
      }

      // FILTER BY URLS
      if (Array.isArray(this.siblingAndChildrenUrls)) {
        if (this.siblingAndChildrenUrls.length === 1) {
          filter.url = {
            equals: this.siblingAndChildrenUrls[0],
          }
        }
        if (this.siblingAndChildrenUrls.length > 1) {
          filter.url = { in: this.siblingAndChildrenUrls }
        }
      }
      return filter
    },

    siblingAndChildrenUrls() {
      if (!this.pagesStructure) {
        return []
      }
      const pageUrls = []
      const amount = 3

      // get siblings urls
      const siblings = this.pagesStructure.siblings
      if (Array.isArray(siblings) && siblings.length > 0) {
        for (let index = 0; index < siblings.length; index++) {
          pageUrls.push(siblings[index].url)
          if (pageUrls.length === amount) {
            break
          }
        }
      }

      // if not enough siblings, get children urls
      const children = this.pagesStructure.children
      if (
        pageUrls.length < amount &&
        Array.isArray(children) &&
        children.length > 0
      ) {
        for (let index = 0; index < children.length; index++) {
          pageUrls.push(children[index].url)
          if (pageUrls.length === 3) {
            break
          }
        }
      }

      return pageUrls
    },

    loadAutomatically() {
      return !(
        this.data.load_cards_automatically.value === 'by_hand' ||
        !this.data.cards
      )
    },
  },

  watch: {
    data: {
      handler(newData) {
        if (this.loadAutomatically) {
          return
        }
        this.cards = newData.cards
      },

      deep: true,
      immediate: true,
    },

    graphQlFilter: {
      handler() {
        if (this.siblingAndChildrenUrls.length < 1 || !this.loadAutomatically) {
          return
        }
        this.getPages()
      },

      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.isTouchDevice = 'ontouchstart' in window
  },

  methods: {
    async getPages() {
      try {
        const res = await this.$graphql.cms.request(getPagesPreview, {
          filter: this.graphQlFilter,
        })
        this.cards = res.entries?.data
      } catch (e) {
        console.log('Cards/getPages', e)
      }
    },
  },
}
